export enum CookieId {
  Session = '__session', // Google will cache this specific key on their CDN
  HasSession = 'hasSession',
  NeedsSessionRefresh = 'needsSessionRefresh',
  NoRedirects = 'noRedirects',
}

export const expired = 'Thu, 01 Jan 1970 00:00:00 UTC';

export function expireCookie(cookie: CookieId | string) {
  document.cookie = `${cookie}=; expires=${expired}; path=/;`;
}
